<template>
  <div class="table">
    <el-table
      :data="allLeavesData"
      @selection-change="handleSelectionChange"
      style="width: 100%"
      empty-text="You are yet to create a Leave"
      @cell-click="cellClick"
      v-loading="loading"
    >
      <div slot="empty">
        <NoDataToView
          v-if="!loading"
          link="/admin/hrm/leave/create"
          :showButton="showCreateLeaveLink"
          btnText="Leave"
        >
          <template slot="message">
            <p>
              {{ noDataMessage }} &nbsp;<button
                v-if="!showCreateLeaveLink"
                @click="$emit('resetTable')"
                class="pointer blue underline"
              >
                clear
              </button>
            </p>
          </template>
        </NoDataToView>
      </div>
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column
        sortable
        prop="id"
        label="ID"
        width="80"
        fixed="left"
      ></el-table-column>
      <el-table-column
        sortable
        prop="employee_name"
        label="EMPLOYEE NAME"
        width="200"
        fixed="left"
      ></el-table-column>
      <el-table-column
        sortable
        prop="leave_type_name"
        label="LEAVE TYPE"
        width="180"
      ></el-table-column>
      <el-table-column
        sortable
        prop="start_date"
        label="START DATE"
        width="180"
        :formatter="dateTableFormatter"
      ></el-table-column>
      <el-table-column
        sortable
        prop="end_date"
        label="END DATE"
        width="180"
        :formatter="dateTableFormatter"
      ></el-table-column>
      <el-table-column
        sortable
        prop="relief"
        label="RELIEF"
        width="180"
        :formatter="tableFormatter"
      ></el-table-column>
      <el-table-column
        sortable
        prop="status"
        label="STATUS"
        width="120"
        fixed="right"
        align="center"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.status === 'pending'" class="status pending">
            Pending
          </div>
          <div v-if="scope.row.status === 'rejected'" class="status reject">
            Rejected
          </div>
          <div v-if="scope.row.status === 'scheduled'" class="status approve">
            Approved
          </div>
          <div v-if="scope.row.status === 'taken'" class="status completed">
            Completed
          </div>
          <div
            v-if="scope.row.status === 'active'"
            class="status active-status"
          >
            Active
          </div>
          <div v-if="scope.row.status === 'cancelled'" class="status cancelled">
            Cancelled
          </div>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="actions"
        label="ACTIONS"
        width="120"
        fixed="right"
      >
        <template slot-scope="scope">
          <div class="actions relative">
            <el-dropdown>
              <span class="el-dropdown-link">
                <img src="/img/more.svg" alt="view" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  @click.native.prevent="$emit('toggleView', scope.row)"
                  >View</el-dropdown-item
                >
                <el-dropdown-item @click.native.prevent="edit(scope.row.id)"
                  >Edit</el-dropdown-item
                >
                <el-dropdown-item
                  class="danger"
                  @click.native.prevent="deleteALeave(scope.row)"
                  >Delete</el-dropdown-item
                >
                <el-dropdown-item
                  v-if="
                    scope.row.status === 'scheduled' ||
                      scope.row.status === 'active'
                  "
                  class="danger"
                  @click.native.prevent="cancelALeave(scope.row)"
                  >Cancel</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        mini
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="pageSizes"
        :page-size="perPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers("admin/hrm/leave");
import { MessageBox } from "element-ui";
import NoDataToView from "@/components/general/NoDataToView.vue";
import {
  dateFormatter,
  tableFormatter,
  dateTableFormatter,
} from "@/helpers/functions";

export default {
  props: [
    "filterDate",
    "searchQuery",
    "resetTable",
    "filterLeaveTypes",
    "filterValue",
  ],
  components: {
    NoDataToView,
  },
  data() {
    return {
      pageSizes: this.$store.state.admin.pageSizes,
    };
  },
  mounted() {
    this.getAllLeaves();
  },
  computed: {
    ...mapState({
      allLeavesData: "leavesData",
      total: "leaveTotal",
      loading: "tableLoading",
      perPage: "perPage",
      leaveTypes: "leaveTypesSearch",
    }),
    currentPage: {
      get() {
        return this.$store.state.admin.hrm.leave.currentPage;
      },
      set(value) {
        return this.$store.commit("admin/hrm/leave/currentPage", value);
      },
    },
    showCreateLeaveLink() {
      return (
        !this.filterValue &&
        !this.filterDate &&
        !this.allLeavesData.length &&
        !this.filterLeaveTypes &&
        !this.searchQuery
      );
    },
    noDataMessage() {
      let message = `No Leave available`;
      const leaveTypes = Array.isArray(this.leaveTypes) ? this.leaveTypes : [];
      const result = leaveTypes.find(item => item.id === this.filterLeaveTypes);
      if (this.showCreateLeaveLink) {
        return message;
      }
      if (this.filterDate) {
        const start_date = dateFormatter(this.filterDate[0]);
        const end_date = dateFormatter(this.filterDate[1]);
        return `${message} ${this.filterValue ? "for " : ""} ${
          this.filterValue
        } from ${start_date} to ${end_date}`;
      }
      if (this.searchQuery !== "") {
        return `${message} ${this.searchQuery ? "for " : ""} ${
          this.searchQuery
        } `;
      }
      if (this.filterLeaveTypes) {
        return `${message} ${this.filterLeaveTypes ? "for " : ""} ${
          result ? result.leave_name : "the selected leave type"
        } `;
      }
      return `${message} ${this.filterValue ? "for " : ""} ${
        this.filterValue
      } leave`;
    },
  },
  methods: {
    dateTableFormatter,
    tableFormatter,
    ...mapActions([
      "handleSizeChange",
      "handleCurrentChange",
      "deleteLeaves",
      "cancelLeaves",
    ]),
    getAllLeaves() {
      this.$store
        .dispatch("admin/hrm/leave/getAllLeaves")
        .then(() => {})
        .catch(() => {});
    },
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },
    toggleView() {
      this.$emit("toggleView");
    },
    edit(id) {
      this.$router.push({ name: "editAdmin-leave", params: { id } });
    },
    cellClick(row, column, cell) {
      const theCell = cell.querySelector(".more-actions");
      if (!theCell) return;
      theCell.classList.toggle("show");
    },
    deleteALeave(row) {
      const id = [row.id];
      this.$promptModal(
        "Delete Leave",
        "This Leave will be deleted",
        "Delete",
        () => this.handleDeleteLeave(id)
      );
    },
    handleDeleteLeave(id) {
      this.loading = true;
      this.deleteLeaves(id)
        .then(() => {
          this.loading = false;
          this.getAllLeaves();
        })
        .catch(error => {
          this.loading = false;
          this.$notification.error(error.message);
        });
    },
    handleCancelLeave(payload) {
      this.loading = true;
      this.cancelLeaves(payload)
        .then(() => {
          this.loading = false;
          this.getAllLeaves();
        })
        .catch(error => {
          this.loading = false;
          this.$notification.error(error.message);
        });
    },
    cancelALeave(row) {
      const id = row.id;
      MessageBox.prompt(
        "Please provide a reason for cancellation",
        "Cancel Leave",
        {
          confirmButtonText: "Cancel Leave",
          cancelButtonText: "Back",
          inputPlaceholder: "Enter cancellation reason",
          inputValidator: value => {
            if (!value || !value.trim())
              return "Cancellation reason is required";
            return true;
          },
          closeOnClickModal: false,
        }
      )
        .then(({ value }) => {
          this.handleCancelLeave({
            id,
            cancellation_reason: value.trim(),
          });
        })
        .catch(() => {});
    },
    /*  formatStatus(row) {
      if (row["status"] === "approved") {
        return "Approved";
      } else if (row["status"] === "pending") {
        return "Pending";
      } else return "Rejected";
    }, */
  },
};
</script>
